import BrandStrategy from "./Components/Strategy/BrandStrategy"
import Header from "./Components/Strategy/Header"
import AdvertisingStrategy from "./Components/Strategy/AdvertisingStrategy"
import SeoStrategy from "./Components/Strategy/SeoStrategy"
import DigitalStrategy from "./Components/Strategy/DigitalStrategy"
import Testimonial from "./Components/Testimonial"
import CTA from "./Components/CTA"

const Strategy = () => {
    return (
        <div className="select-none">
            <Header></Header>
            <BrandStrategy></BrandStrategy>
            <AdvertisingStrategy></AdvertisingStrategy>
            <SeoStrategy></SeoStrategy>
            <DigitalStrategy></DigitalStrategy>
            {/* <Testimonial></Testimonial> */}
            <CTA></CTA>
        </div>
    )
}

export default Strategy